<template>
  <div>
    <el-button icon="el-icon-refresh" @click="refreshList" class="refresh-btn">刷新</el-button>
    <div class="storemanage add-dept-storemanage">
      <div class="search">
        <el-form :inline="true" :model="searchForm">
          <el-form-item label="科室名称">
            <el-input v-model.trim="searchForm.departmentName" placeholder="请输入科室名称" clearable />
          </el-form-item>
          <el-form-item>
            <el-button type="primary" icon="el-icon-search" @click="searchList">查询</el-button>
            <el-button icon="el-icon-refresh" @click="resetSearch">重置</el-button>
          </el-form-item>
        </el-form>
      </div>

      <div class="button">
        <el-button icon="el-icon-plus" type="primary" @click="openAddDialog">新增科室</el-button>
      </div>

      <el-table v-loading="loading" border :data="tableData" ref="multipleTable" :max-height="tableHeight"
        @selection-change="val => $handleSelectionChange(val, true)">
        <el-table-column type="index" label="序号" width="50" fixed="left" />
        <el-table-column prop="departmentName" label="科室名称" width="200" fixed="left" />
        <el-table-column prop="departmentType" label="科室类型" width="150">
          <template slot-scope="scope">
            {{ dictText(scope.row.departmentType, departmentTypeOptions) }}
          </template>
        </el-table-column>
        <el-table-column prop="primaryMedicalSubject" label="一级诊疗科目" width="180" />
        <el-table-column prop="acceptRegisterText" label="是否接受挂号、预约" width="160">
          <template slot-scope="scope">
            {{ scope.row.isRegistrationEnabled === 1 ? '是' : '否' }}
          </template>
        </el-table-column>
        <el-table-column prop="bedCount" label="科室床位数" width="150" />
        <el-table-column prop="deptName" label="医馆" width="150" />
        <el-table-column prop="createTime" label="创建时间" />
        <el-table-column label="操作" fixed="right">
          <template slot-scope="scope">
            <el-button icon="el-icon-edit" type="primary" @click="openEditDialog(scope.row)">编辑</el-button>
            <el-button icon="el-icon-delete" type="danger" @click="deleteDept(scope.row)">删除</el-button>
            <el-button size="mini" @click="openDoctorDialog(scope.row)">绑定医生</el-button>
          </template>
        </el-table-column>
      </el-table>

      <el-dialog class="deptEdit" :title="dialogTitle" :visible.sync="dialogVisible" width="960px"
        :before-close="done => $handleClose(done, 'editForm')" :close-on-click-modal="false">
        <el-form :model="editForm" ref="deptForm" label-width="150px" :rules="rules" inline>
          <el-form-item label="所属医馆" prop="deptId">
            <el-select v-model="editForm.deptId" placeholder="请选择所属医馆" filterable clearable>
              <el-option v-for="item in hospitalOptions" :key="item.deptId" :label="item.deptName"
                :value="item.deptId" />
            </el-select>
          </el-form-item>
          <el-form-item label="科室类型" prop="departmentType">
            <el-select v-model="editForm.departmentType" placeholder="请选择科室类型" clearable>
              <el-option v-for="item in departmentTypeOptions" :key="item.value" :label="item.label"
                :value="item.value" />
            </el-select>
          </el-form-item>
          <el-form-item label="科室名称" prop="departmentName">
            <el-input v-model.trim="editForm.departmentName" placeholder="请输入科室名称" />
          </el-form-item>
          <el-form-item label="诊疗科目" prop="primaryMedicalSubject">
            <el-input v-model.trim="editForm.primaryMedicalSubject" placeholder="请输入诊疗科目" />
          </el-form-item>
          <el-form-item label="是否接受挂号、预约" prop="isRegistrationEnabled">
            <el-radio-group v-model="editForm.isRegistrationEnabled">
              <el-radio :label="1">是</el-radio>
              <el-radio :label="0">否</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="科室成立时间" prop="establishedDate">
            <el-date-picker v-model="editForm.establishedDate" type="date" value-format="yyyy-MM-dd" format="yyyy-MM-dd"
              placeholder="请选择成立时间" clearable />
          </el-form-item>
          <el-form-item label="科室联系电话" prop="contactPhone">
            <el-input v-model.trim="editForm.contactPhone" placeholder="请输入科室联系电话" />
          </el-form-item>
          <el-form-item label="科室床位数" prop="bedCount">
            <el-input-number v-model="editForm.bedCount" :min="0" :max="999" />
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button type="success" @click="submitDept">保存</el-button>
          <el-button @click="closeEditDialog">取 消</el-button>
        </span>
      </el-dialog>

      <el-dialog class="doctor-dialog" title="医生列表" :visible.sync="doctorDialogVisible" width="1060px"
        :before-close="closeDoctorDialog" :close-on-click-modal="false">
        <div class="doctor-dialog-action">
          <span class="doctor-dialog-label">添加医生：</span>
          <el-select v-model="doctorId" filterable default-first-option placeholder="请选择医生" class="doctor-select">
            <el-option v-for="item in doctorOptions" :key="item.value" :label="item.label" :value="item.value" />
          </el-select>
          <el-button type="primary" @click="bindDoctors">绑定医生</el-button>
        </div>

        <el-table :data="addDoctorForm.currentDoctorList" border class="doctor-table">
          <el-table-column prop="doctorName" label="姓名" min-width="150" />
          <el-table-column prop="sex" label="性别" min-width="150">
            <template slot-scope="scope">
              {{ scope.row.sex === '1' ? '男' : '女' }}
            </template>
          </el-table-column>
          <el-table-column prop="doctorTitle" label="职称" min-width="150" />
          <el-table-column label="科室负责人" min-width="250">
            <template slot-scope="scope">
              <el-radio-group v-model="addDoctorForm.leaderDoctorId">
                <el-radio :label="scope.row.doctorId">设置为科室负责人</el-radio>
              </el-radio-group>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="140">
            <template slot-scope="scope">
              <el-button type="text" @click="removeDoctor(scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <span slot="footer" class="dialog-footer doctor-dialog-footer">
          <el-button type="primary" @click="confirmDoctorDialog">确定</el-button>
          <el-button @click="closeDoctorDialog">取消</el-button>
        </span>
      </el-dialog>

      <el-pagination class="position-s" @current-change="page => handlePageChange(page)" :current-page="searchForm.currentPage"
        :page-size="searchForm.pageSize" layout="total, prev, pager, next, jumper" :total="total" />
    </div>
  </div>
</template>

<script>
import { addDepartment, getDepartmentPage, editDepartment, deleteDepartment, getDepartmentInfo, getDepartmentDoctors, bindDepartmentDoctors } from '@/api/post'
import { getEffectiveDeptList } from '@/api/hospital'
import { dictText } from '@/utils/validateBase'
import { isNull } from 'lodash'
import { isNullObj } from '../../../../utils/validateBase'
const departmentTypeOptions = [
  { label: '临床科室', value: 1 },
  { label: '检查科室', value: 2 },
  { label: '检验科室', value: 3 },
  { label: '职能科室', value: 4 },
]

export default {
  name: 'AddDept',
  data() {
    return {
      loading: false,
      saveLoading: false,
      searchForm: {
        deptId: this.$session.get('deptId') > 0 ? this.$session.get('deptId') : null,
        departmentName: '',
        currentPage: 1,
        pageSize: 10,
      },
      total: 0,
      tableHeight: 0,
      dialogVisible: false,
      dialogTitle: '',
      editForm: {},
      tableData: [],
      rules: {
        deptId: [{ required: true, message: '请选择所属医馆', trigger: 'change' }],
        departmentType: [{ required: true, message: '请选择科室类型', trigger: 'change' }],
        departmentName: [{ required: true, message: '请输入科室名称', trigger: 'blur' }],
        primaryMedicalSubject: [{ required: true, message: '请输入诊疗科目', trigger: 'blur' }],
        isRegistrationEnabled: [{ required: true, message: '请选择是否接受挂号、预约', trigger: 'change' }],
        establishedDate: [{ required: true, message: '请选择科室成立时间', trigger: 'change' }],
        contactPhone: [
          { required: true, message: '请输入科室联系电话', trigger: 'blur' },
          { min: 5, max: 20, message: '联系电话长度不正确', trigger: 'blur' }
        ],
        bedCount: [{ required: true, message: '请输入科室床位数', trigger: 'change' }]
      },
      doctorDialogVisible: false,
      doctorId: '',
      departmentTypeOptions,
      hospitalOptions: [],
      dictText:dictText,
      doctorOptions:[],
      addDoctorForm: {
        departmentId: null,
        currentDoctorList:[],
        leaderDoctorId: null
      }
    }
  },
  created() {
    this.tableHeight = document.documentElement.clientHeight - 330
    this.getEffectiveDeptList()
    this.getDepartmentPage()
    this.$getDoctorOptions({ type: 0, status: 0 }); // 获取所有馆内在职医生
  },
  methods: {
    async getDepartmentPage() {
      const { code, rows, total } = await getDepartmentPage(this.searchForm)
      if (code === 200) {
        this.tableData = rows
        this.total = total
      }
    },
    async getEffectiveDeptList() {
      const { code, data } = await getEffectiveDeptList()
      if (code === 200) {
        this.hospitalOptions = data
      }
    },
    refreshList() {
      this.searchForm.currentPage = 1
      this.getDepartmentPage()
    },
    searchList() {
      this.searchForm.currentPage = 1
      this.getDepartmentPage()
    },
    resetSearch() {
      this.searchForm.departmentName = ''
      this.searchForm.currentPage = 1
      this.getDepartmentPage()
    },
    handlePageChange(page) {
      this.searchForm.currentPage = page
      this.getDepartmentPage()
    },
    openAddDialog() {
      this.dialogTitle = '新增科室'
      this.editForm = {
        deptId: this.$session.get('deptId'),
        departmentType: '',
        departmentName: '',
        primaryMedicalSubject: '',
        isRegistrationEnabled: 1,
        createDate: '',
        contactPhone: '',
        bedCount: 0,
      }
      this.dialogVisible = true
    },
    openEditDialog(row) {
      this.dialogTitle = '编辑科室'
      getDepartmentInfo({id:row.id}).then(res => {
        if (res.code === 200) {
          this.editForm = res.data
          this.dialogVisible = true
        }
      })
    },
    closeEditDialog() {
      this.dialogVisible = false
      this.saveLoading = false
      this.$nextTick(() => {
        if (this.$refs.deptForm) this.$refs.deptForm.clearValidate()
      })
    },
    submitDept() {
      this.$refs.deptForm.validate(valid => {
        if (!valid) return
        this.saveLoading = true
        if (this.editForm.id) {
          editDepartment(this.editForm).then(res => {
            if (res.code === 200) {
              this.$message.success('修改成功')
              this.closeEditDialog()
              this.getDepartmentPage()
            }
          })
        } else {
          addDepartment(this.editForm).then(res => {
            if (res.code === 200) {
              this.$message.success('新增成功')
              this.closeEditDialog()
              this.getDepartmentPage()
            }
          })
        }
        this.saveLoading = false
        this.closeEditDialog()
      })
    },
    deleteDept(row) {
      this.$confirm(`确认删除科室${row.departmentName}吗？`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let ids = [row.id]
        deleteDepartment({ids}).then(res => {
          if (res.code === 200) {
            this.$message.success('删除成功')
            this.getDepartmentPage()
          }
        })
      }).catch(() => { })
    },
    openDoctorDialog(row) {
      this.addDoctorForm.departmentId = row.id
      getDepartmentDoctors({departmentId:row.id}).then(res => {
        if (res.code === 200) {
          this.addDoctorForm.currentDoctorList = res.data
          let leaderDoctor = res.data.find(item => item.isLeader === 1)
          if(leaderDoctor) {
            this.addDoctorForm.leaderDoctorId = leaderDoctor.doctorId
          }
          this.doctorId = ''
          this.doctorDialogVisible = true
          }
      })
    },
    closeDoctorDialog(done) {
      if (typeof done === 'function') done()
      this.doctorDialogVisible = false
      this.addDoctorForm.currentDoctorList = []
      this.addDoctorForm.leaderDoctorId = null
      this.addDoctorForm.departmentId = null
      this.doctorId = ''
    },
    confirmDoctorDialog() {
      if(isNull(this.addDoctorForm.leaderDoctorId)) {
        this.$message.warning('请选择科室负责人')
        return
      }
      let doctors = []
      this.addDoctorForm.currentDoctorList.forEach(item => {
        doctors.push({doctorId:item.doctorId,isLeader:item.doctorId === this.addDoctorForm.leaderDoctorId ? 1 : 0})
      })
      let params = { departmentId: this.addDoctorForm.departmentId,doctors}
      bindDepartmentDoctors(params).then(res => {
        if (res.code === 200) {
          this.$message.success('绑定成功')
          this.closeDoctorDialog()
          this.getDepartmentPage()
        }
      })
    },
    bindDoctors() {
      if (!this.doctorId) {
        this.$message.warning('请选择医生')
        return
      }
      const selected = this.doctorOptions.find(item => item.value === this.doctorId)
      let findIndex = this.addDoctorForm.currentDoctorList.findIndex(item => item.doctorId === selected.value)
      if(findIndex !== -1) {
        this.$message.warning('该医生已存在于当前科室')
        return
      }
      const nextDoctor = {
        doctorId: selected.value,
        doctorName: selected.label,
        sex: selected.sex,
        doctorTitle: selected.doctorTitle,
      }
      this.doctorId = ''
      this.addDoctorForm.currentDoctorList.push(nextDoctor)
    },
    removeDoctor(row) {
      let findIndex = this.addDoctorForm.currentDoctorList.findIndex(item => item.doctorId === row.doctorId)
      if(findIndex !== -1) {
        this.addDoctorForm.currentDoctorList.splice(findIndex, 1)
      }
    },
  }
}
</script>

<style lang="less" scoped>
.refresh-btn {
  float: right;
  margin-bottom: 20px;
}

.storemanage {
  clear: both;

  &>div:not(:last-child) {
    margin-bottom: 20px;
  }

  .search {
    .el-form-item {
      margin-bottom: 0;
    }
  }

  .button {
    margin-bottom: 12px;
  }

  .deptEdit {
    .el-form-item {
      width: 400px;
      margin-bottom: 10px !important;

      .el-input,
      .el-textarea,
      /deep/.el-form-item__content,
      /deep/.el-input-number,
      /deep/.el-select {
        width: 250px;
      }
    }
  }
}

.deptEdit {
  /deep/ .el-dialog__body {
    padding-top: 16px;
  }

  .el-form {
    display: flex;
    flex-wrap: wrap;
  }

  .el-form-item {
    width: 400px;
    margin-bottom: 10px !important;

    .el-input,
    .el-textarea,
    /deep/.el-form-item__content,
    /deep/.el-input-number,
    /deep/.el-select {
      width: 250px;
    }
  }
}

.doctor-dialog {
  /deep/ .el-dialog__body {
    padding: 22px 24px 12px;
  }

  .doctor-dialog-action {
    display: flex;
    align-items: center;
    margin-bottom: 16px;
    flex-wrap: wrap;
  }

  .doctor-dialog-label {
    font-size: 16px;
    color: #333;
    margin-right: 10px;
    flex-shrink: 0;
  }

  .doctor-select {
    width: 240px;
    margin-right: 8px;
  }

  .doctor-table {
    margin-top: 8px;

    /deep/ .el-table__header-wrapper th {
      background: #fafafa;
      color: #333;
    }

    /deep/ .cell {
      text-align: center;
    }
  }

  .doctor-dialog-footer {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    padding-top: 8px;
  }
}

.el-image {
  width: auto;
  height: 60px;
  margin-top: 5px;
}

.position-s {
  margin-top: 20px;
  text-align: right;
}
</style>